// extracted by mini-css-extract-plugin
module.exports = {"sidebarNav":"SidebarNav_sidebarNav__dwHo_"};